'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('../../../../../../dist-es6/client/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ReportTimelineScheduleDirective=function(_BaseControllerBacked){_inherits(ReportTimelineScheduleDirective,_BaseControllerBacked);function ReportTimelineScheduleDirective(){_classCallCheck(this,ReportTimelineScheduleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ReportTimelineScheduleDirective,[{key:'objectBindings',get:function()
{
return[
'displayTimeZone',
'timezoneDescription',
'timeOfLastHosStatus',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'weekFormatter',
'sleepFormatter',
'personalStatistics',
'multiViewParent'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/fatigueReport/components/reportTimelineSchedule/reportTimelineScheduleView';
}},{key:'controller',get:function()

{
return ReportTimelineScheduleDirectiveController;
}}]);return ReportTimelineScheduleDirective}(BaseControllerBackedDirective);let


ReportTimelineScheduleDirectiveController=function(){
function ReportTimelineScheduleDirectiveController($scope,$element,$timeout,displaySettingsService){var _this2=this;_classCallCheck(this,ReportTimelineScheduleDirectiveController);

this._$timeout=$timeout;
this._dailySummaryColumnWidth=86;
this._element=$element[0];

const{fatigue:fatigue,sleep:sleep,queryInterval:queryInterval}=this.personalSchedule;
this._fatiguePoints=TimeSeries.assignWhenIntersectingOrOutside(fatigue,sleep,{notRendered:!0},queryInterval);

$scope.$watch('controller.personalSchedule',function(newSchedule,oldSchedule){
if(newSchedule.queryInterval.equals(oldSchedule.queryInterval)){
return;
}

$timeout(function(){return _this2.multiViewParent.reloadCurrentView()});
});

$scope.$on('resize::resize',function(){return _this2._onDimensionsChanged()});

this._onDimensionsChanged();
}ReportTimelineScheduleDirectiveController.prototype.





















_onDimensionsChanged=function _onDimensionsChanged(newDimensions,oldDimensions){var _this3=this;
const newWidth=Math.floor((this.dailyDetailColumnsContainer.offsetWidth-this.detailsLabelColumn.offsetWidth)/7);

if(newWidth===this.dailySummaryColumnWidth){
return;
}

this._$timeout(function(){
_this3.dailySummaryColumnWidth=newWidth;
});
};_createClass(ReportTimelineScheduleDirectiveController,[{key:'fatiguePoints',get:function(){return this._fatiguePoints}},{key:'dailyDetailColumnsContainer',get:function(){return this._dailyDetailColumnsContainer||(this._dailyDetailColumnsContainer=angular.element(this._element).find('.schedule-daily-detail-columns')[0])}},{key:'detailsLabelColumn',get:function(){return this._detailsLabelColumn||(this._detailsLabelColumn=angular.element(this._element).find('.schedule-row-titles-column')[0])}},{key:'dailySummaryColumnWidth',set:function(newWidth){this._dailySummaryColumnWidth=newWidth},get:function(){return this._dailySummaryColumnWidth}}]);return ReportTimelineScheduleDirectiveController}();


module.exports=ReportTimelineScheduleDirective;
//# sourceMappingURL=reportTimelineScheduleDirective.js.map
